import store from "../utils/store";

class UtilReducer {
    commonReducer(type, data) {
        store.dispatch({
            type: type,
            data: data,
        });
    }

    addRemoveProducts(products, total) {
        store.dispatch({
            type: "ADD_REMOVE_PRODUCTS",
            data: {
                products: products,
                total: total,
            },
        });
    }
}

const utilReducer = new UtilReducer();

export default utilReducer;
